import { Chip } from '@stern-ui/ui';
import { useParams } from 'react-router-dom';

import { CellContextExtended, PersonListObject } from '../../types';

type ListParams = {
	list_identifier: string;
};

// This component is used to display a "New" chip for patients that are marked as new in a patient list.
// List ID is taken from the URL params and patient ID is taken from the row data.

export const ListPatientsNewChip = ({ info }: { info: CellContextExtended }) => {
	const { list_identifier } = useParams<ListParams>();
	const { id } = info.row.original as PersonListObject;

	const removeNew = (_listId: string, _patientId: string) => {
		// TODO: API call to remove the "new" status for the patient in the list
		// console.log(`Removing "new" status for patient ${patientId} in list ${listId}`);
	};

	return (
		<Chip
			size='sm'
			style='new'
			value='New'
			className='inline-flex items-center justify-between'
			buttonClassName='hover:text-success ml-1'
			dataTestId='list-patient-new-chip'
			onClose={() => removeNew(list_identifier ?? '', id)}
		/>
	);
};
